// extracted by mini-css-extract-plugin
module.exports = {"container":"FeasibilityCheckerPage_container__3qm4u","title":"FeasibilityCheckerPage_title__CW9Cx"};